// ============================================================
// Wer darf was — dieselbe Rechnung wie das Backend (SPEC §2.3, app/rechte.py).
// Die Oberfläche zeigt einen Knopf nur, wenn der Server ihn auch annimmt; ein
// Knopf, der beim Drücken 403 wirft, ist schlimmer als keiner.
// ============================================================
import type { Rolle } from "../api/types";

export function istAdmin(rolle: Rolle | null | undefined): boolean {
  return rolle === "admin";
}

/** Bibliotheksvorschläge bestätigen, Kategorien und Büroregeln pflegen, Nutzer verwalten,
 *  Katalog löschen (§2.3) — alles nur Admin. */
export const darfVerwalten = istAdmin;
